/**
 * How touch input drives movement on mobile.
 *
 * 'joystick' — a fixed on-screen stick (bottom-left) for forward/strafe, drag
 * anywhere else to look. The standard pattern for mobile first-person
 * controls (nipplejs and most three.js FPS demos converge on it) — discoverable,
 * and doesn't fight the browser's native pinch-zoom the way a 2-finger
 * movement gesture does.
 * 'gesture' — the original pinch-to-move: spread two fingers to walk forward,
 * pinch together to back up. Kept as an opt-in for anyone who prefers it.
 */
export type ControlMode = 'gesture' | 'joystick'

export const DEFAULT_CONTROL_MODE: ControlMode = 'joystick'

const STORAGE_KEY = 'mall3d:controlMode'

export function loadControlMode(): ControlMode {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'gesture' || saved === 'joystick') return saved
  } catch { /* private mode / storage disabled */ }
  return DEFAULT_CONTROL_MODE
}

export function saveControlMode(mode: ControlMode) {
  try { localStorage.setItem(STORAGE_KEY, mode) } catch { /* non-fatal */ }
}
